import { HIDDEN_ROLE_TYPES } from "../../domain/entities/Role";
import { mapRole } from "./UserListMapper";
/** Maps a raw BFF user-detail object (snake_case) to the ManagedUser domain entity. */
export function mapResponseToManagedUser(raw) {
    return {
        id: String(raw.id ?? ""),
        email: String(raw.email ?? ""),
        firstName: String(raw.first_name ?? ""),
        lastName: String(raw.last_name ?? ""),
        locale: String(raw.preferred_language ?? raw.locale ?? ""),
        enabled: raw.enabled === true,
        isInvited: raw.is_invited === true,
        phoneCountryCode: raw.phone_country_code,
        phoneNationalNumber: raw.phone_national_number,
        department: raw.department,
        jobTitle: raw.job_title,
        avatarUri: raw.avatar_uri,
        roles: Array.isArray(raw.roles)
            ? raw.roles.filter((type) => !HIDDEN_ROLE_TYPES.includes(type))
            : [],
        assignedRoles: Array.isArray(raw.assigned_roles)
            ? raw.assigned_roles
                .map(mapRole)
                .filter((role) => !HIDDEN_ROLE_TYPES.includes(role.type))
            : [],
        properties: mapProperties(raw.properties),
    };
}
/** Null when the BFF sends no block, so an older BFF stays safe to render. */
function mapProperties(raw) {
    if (!raw || typeof raw !== "object")
        return null;
    const block = raw;
    return {
        createdAt: block.created_at ?? null,
    };
}
